import { Injectable, Renderer2, Inject } from '@angular/core';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
import { KeysDefaultBehavior } from 'angular-engine/engine/service/ui/input-devices/keys.default.behavior.service';

@Injectable()
export class InteractiveComponentService {
    renderer: Renderer2

    constructor( @Inject(APP_SETTINGS) protected settings: any,
        protected keysService: KeysDefaultBehavior) {
    }


    updateNotificationDataSourceFromMessage(message?: any, component?: any, notifcation?: any) {
        if (!component || !component.data) return;

        const targetIndex = component.data.findIndex(i => i.meta && i.meta.obj_type == "Notification");
        if (message) {
            if (targetIndex < 0 && notifcation) component.data.push(notifcation);
        } else {
            if (targetIndex && targetIndex > -1) {
                // reset focused index if necessary
                if (component.focusedItemIndex != 0) {
                    this.keysService.resetComponentDefaultFocusedItem(component);
                    if (!component.isActive) {
                        if (component.verticalScrollingEnabled) {
                            component.requestVerticalScroll(null)
                        } else {
                            component.scrollHorizontally(null)
                        }
                    }
                }
                component.data.splice(targetIndex, 1)
            }
        }

        component.refresh()
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/components/interactive-component.ott.service.ts